module.exports = "/shared/img/ticket-background-light.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/ticket-background-light.png
// module id = 453
// module chunks = 13